import { AnyAction } from 'redux';

interface IUpdateLocation {
    loading: boolean;
}

const initialState: IUpdateLocation = {
    loading: false,
};
export const UpdateLocation = (state = initialState, action: AnyAction) => {
    switch (action.type) {
        case 'LOADING_UPDATE_LOCATION':
            return {
                ...state,
                loading: action.payload,
            };
        default:
            return state;
    }
};
